<template>
  <div class="surface-selection">
    <p class="h3 mb-2 pt-2 pb-4" v-if="state.room_type">Quelle est la surface de votre {{ getRoom(state.room_type).toLowerCase() }} en m<sup>2</sup> ? </p>

    <div class="row two-parts">
      <div class="col-lg-5 px-5 px-md-0 pr-md-5 ">
        <img v-if="state.room_type" class="w-100" :src="require('@/assets/img/pieces/'+state.room_type+'.svg')">
      </div>
      <div class="col-lg-6 px-4 d-flex flex-column justify-content-center pt-5">
        <div class="d-flex justify-content-between align-items-center pb-3">
          <button class="ml-3 more-btn" @click='value+=-1'><i class="fas fa-minus-circle"></i></button>
          <p class="h1">{{value}} m<sup><small>2</small></sup></p>
          <button class="mr-3 more-btn" @click='value+=1'><i class="fas fa-plus-circle"></i></button>
        </div>
        <div class="form-group mb-4">
          <vue-range-slider :min="5" :max="100" ref="slider" v-model="value" tooltip="hover" tooltip-dir="bottom" formatter="{value} m"></vue-range-slider>
          <div class="caption-range mt-2">
            <span class="min">5 m<sup>2</sup></span>
            <span class="max">100 m<sup>2</sup></span>
          </div>
        </div>
        <router-link :to="{name:'PowerShow'}" tag="button" class="btn mt-3 btn-md btn-primary rounded-pill">
          Étape suivante
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-range-component/dist/vue-range-slider.css';
  import VueRangeSlider from 'vue-range-component';

  export default {
    name: "SurfaceSelection",
    data() {
      return {
        value: 10
      }
    },
    created(){
      if (this.state.surface)this.value = this.state.surface;
    },
    watch:{
      value(){
        this.setData('surface',this.value)
      }
    },
    components: {VueRangeSlider}
  }
</script>

